module.exports = __webpack_public_path__ + "flaticon.9e26a98fa4e95681c0e2";


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/scss/multi-sports/flaticon.woff
// module id = ../../../../../src/scss/multi-sports/flaticon.woff
// module chunks = styles